import { render } from "./after_sale_lists.vue?vue&type=template&id=3a5fc5b5&scoped=true&ts=true"
import script from "./after_sale_lists.vue?vue&type=script&lang=ts"
export * from "./after_sale_lists.vue?vue&type=script&lang=ts"

import "./after_sale_lists.vue?vue&type=style&index=0&id=3a5fc5b5&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5fc5b5"]])

export default __exports__